import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageStack16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconImageStack16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 3H5a1 1 0 0 0-1 1h7a2 2 0 0 1 2 2v5a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1m-1 9V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4.317l2.732-1.739.338-.215.284.283L9.707 13H11a1 1 0 0 0 1-1m-2.5 2H11a2 2 0 0 0 2-2 2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2 2 2 0 0 0-2 2v6a2 2 0 0 0 2 2zm-1.207-1H3a1 1 0 0 1-1-1v-.52a.5.5 0 0 0 .126-.058L4.93 9.637zm.957-4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 1a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImageStack16);
